<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <!-- 搜索区域 -->
      <a-form layout="inline">
        <a-row :gutter="10">
          <a-col :md="10" :sm="12">
            <mtc-form-item label="label.userAccount" :labelCol="labelCol" style="margin-left:8px">
              <a-input :placeholder="$t('label.pleaseEnterAccount')" v-model="queryParam.username" @keyup.enter="searchQuery" />
            </mtc-form-item>
          </a-col>
          <!--<a-col :md="8" :sm="8">-->
          <!--<a-form-item label="用户名称" :labelCol="{span: 5}" :wrapperCol="{span: 18, offset: 1}">-->
          <!--<a-input placeholder="请输入名称查询" v-model="queryParam.realname"></a-input>-->
          <!--</a-form-item>-->
          <!--</a-col>-->
          <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
            <a-col :md="6" :sm="24">
             <!--<a-button type="primary" @click="searchQuery" icon="search" style="margin-left: 18px">{{$t('button.search')}}</a-button>-->
              <!--<a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{$t('button.reset')}}</a-button>-->
              <mtc-button @click="searchQuery" type="primary" icon="search"  text="button.search"></mtc-button>
              <mtc-button @click="searchReset" type="primary" icon="reload"  style="margin-left: 8px" text="button.reset"></mtc-button>
            </a-col>
          </span>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator" :md="24" :sm="24" style="margin-top: -15px">
      <!--<a-button @click="handleEdit" type="primary" icon="edit" style="margin-top: 16px">用户编辑</a-button>-->
      <!--<a-button @click="handleAddUserDepart" type="primary" icon="plus">添加已有用户</a-button>-->
      <!--<a-button @click="handleAdd" type="primary" icon="plus" style="margin-top: 16px">新建用户</a-button>-->
<!--      <mtc-button @click="handleAddUserDepart" type="primary" icon="plus"  text="modalTitle.addExistingUser"></mtc-button>-->
      <mtc-button @click="handleAdd" type="primary" icon="plus"  style="margin-left: 8px" text="modalTitle.newAddUser"></mtc-button>

      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete"/>
            取消关联
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{$t('button.batchOperation')}}
          <a-icon type="down"/>
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{$t('tip.selected')}} <a style="font-weight: 600">{{
        selectedRowKeys.length }}</a>{{$t('tip.term')}}
        <a style="margin-left: 24px" @click="onClearSelected">{{$t('button.clear')}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :scroll="{ x: 'fit-content',y: tableHeight }"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <template v-for="(item, index) in columns" :slot="item.slotName">
          <!--<span :key="index">{{ $t(item.slotName) }}</span>-->
          <mtcHeader :key="index" :text="item.slotName" />
        </template>


        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" >{{$t('button.edit')}}</a>

          <a-divider type="vertical"/>

          <a-dropdown>
            <a class="ant-dropdown-link">
              {{$t('button.more')}} <a-icon type="down"/>
            </a>
            <a-menu slot="overlay">
                <a-menu-item>
                <a href="javascript:;" @click="handleDeptRole(record)">分配部门角色</a>
              </a-menu-item>

              <a-menu-item>
                <a href="javascript:;" @click="handleDetail(record)">用户详情</a>
              </a-menu-item>

              <a-menu-item>
                <a-popconfirm title="确定取消与选中部门关联吗?" @confirm="() => handleDelete(record.id)">
                  <a>取消关联</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>


      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <user-modal ref="modalForm" @ok="modalFormOk"></user-modal>
    <Select-User-Modal ref="selectUserModal" @selectFinished="selectOK"></Select-User-Modal>
    <dept-role-user-modal ref="deptRoleUser"></dept-role-user-modal>
  </a-card>
</template>

<script>
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import {getAction, postAction, deleteAction} from '@/api/manage'
  import SelectUserModal from './SelectUserModal'
  import UserModal from './UserModal'
  import DeptRoleUserModal from './DeptRoleUserModal'
  import { MTC_AUTH } from '@api/servers'

  export default {
    name: "DeptUserInfo",
    mixins: [JeecgListMixin],
    components: {
      DeptRoleUserModal,
      SelectUserModal,
      UserModal
    },
    data() {
      return {
        description: '用户信息',
        currentDeptId: '',
        departTree: [],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        // 表头
        columns: [{
            slotName: 'label.userAccount',
            // title: '用户账号',
            align: "center",
            dataIndex: 'username',
            width: 150,
          scopedSlots: { title: 'label.userAccount'}
          },
          {
            slotName: 'tableHeader.yonghumingcheng',
            // title: '用户名称',
            align: "center",
            width: 150,
            dataIndex: 'realname',
            scopedSlots: { title: 'tableHeader.yonghumingcheng'}
          },
          {
            slotName: 'tableHeader.department',
            // title: '部门',
            align: "center",
            width: 400,
            dataIndex: 'orgCode',
            scopedSlots: { title: 'tableHeader.department'}
          },
          {
            slotName: 'tableHeader.sex',
            // title: '性别',
            align: "center",
            width: 100,
            dataIndex: 'sex_dictText',
            scopedSlots: { title: 'tableHeader.sex'}
          },
          {
            slotName: 'tableHeader.phoneNumber',
            // title: '电话',
            align: "center",
            width: 150,
            dataIndex: 'phone',
            scopedSlots: { title: 'tableHeader.phoneNumber'}
          },
          {
            slotName: 'tableHeader.operation',
            // title: '操作',
            dataIndex: 'action',
            scopedSlots: {customRender: 'action', title: 'tableHeader.operation'},
            align: "center",
            fixed: 'right',
            width: 150
          },
          ],
        url: {
          list: `${ MTC_AUTH }sys/user/departUserList`,
          edit: `${ MTC_AUTH }sys/user/editSysDepartWithUser`,
          delete: `${ MTC_AUTH }sys/user/deleteUserInDepart`,
          deleteBatch: `${ MTC_AUTH }sys/user/deleteUserInDepartBatch`,
        }
      }
    },
    computed: {
      // 列表高度
      tableHeight() {
        return window.innerHeight - 200
      },
    },

    methods: {
      searchReset() {
        this.queryParam = {}
        this.loadData(1);
      },
      loadData(arg) {
        if (!this.url.list) {
          this.$message.error(this.$t('tip.pleaseSet') + "url.list!")
          return
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        //if (this.currentDeptId === '') return;
        var destIds=[]
        this.getDeptIds(this.departTree,destIds)
        let params = this.getQueryParams();//查询条件
        params.depId = this.currentDeptId;
        getAction(this.url.list, params).then((res) => {
          if (res.success && res.result) {
            var records=[]
            for(var i=0;i<res.result.records?.length;i++)
            {
              var rcd=res.result.records[i]
              if(destIds.indexOf(rcd.belongOrg)>-1)    rcd.state=false
              else  rcd.state=true
              records.push(rcd)
            }
            this.dataSource = records;
            this.ipagination.total = res.result.total;
          }
        })
      },
      getDeptIds: function(deptList,destIds){
        for(var i=0;i<deptList?.length;i++)
        {
          destIds.push(deptList[i].value)
          if(deptList[i].isLeaf) continue
          this.getDeptIds(deptList[i].children,destIds)
        }
      },
      batchDel: function () {

        if (!this.url.deleteBatch) {
          this.$message.error(this.$t('tip.pleaseSet') + "url.deleteBatch!")
          return
        }
        if (!this.currentDeptId) {
          this.$message.error("未选中任何部门，无法取消部门与用户的关联!")
          return
        }

        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning(this.$t('tip.pleaseSelectARecord'));
          return;
        } else {
          var ids = "";
          for (var a = 0; a < this.selectedRowKeys.length; a++) {
            ids += this.selectedRowKeys[a] + ",";
          }
          var that = this;
          this.$confirm({
            title: "确认取消",
            content: "是否取消用户与选中部门的关联?",
            onOk: function () {
              deleteAction(that.url.deleteBatch, {depId: that.currentDeptId, userIds: ids}).then((res) => {
                if (res.success) {
                  that.$message.success("删除用户与选中部门关系成功！");
                  that.loadData();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              });
            }
          });
        }
      },
      handleDelete: function (id) {
        if (!this.url.delete) {
          this.$message.error(this.$t('tip.pleaseSet') + "url.delete!")
          return
        }
        if (!this.currentDeptId) {
          this.$message.error("未选中任何部门，无法取消部门与用户的关联!")
          return
        }

        var that = this;
        deleteAction(that.url.delete, {depId: this.currentDeptId, userId: id}).then((res) => {
          if (res.success) {
            that.$message.success("删除用户与选中部门关系成功！");
            if (this.selectedRowKeys.length>0){
               for(let i =0; i<this.selectedRowKeys.length;i++){
                   if (this.selectedRowKeys[i] == id){
                     this.selectedRowKeys.splice(i,1);
                     break;
                   }
               }
            }
            that.loadData();
          } else {
            that.$message.warning(res.message);
          }
        });
      },
      open(record) {
        //console.log(record);
        this.currentDeptId = record.id;
        this.loadData(1);
      },
      clearList() {
        this.currentDeptId = '';
        this.dataSource = [];
      },
      hasSelectDept() {
        if (this.currentDeptId == '') {
          this.$message.error("请选择一个部门!")
          return false;
        }
        return true;
      },
      handleAddUserDepart() {
        if (this.currentDeptId == '' ) {
          this.$message.error("请选择一个部门!")
        } else {
          //设置参数，默认用qq传递参数，查询开始立即处理
          this.$refs.selectUserModal.transQueryParam={"qq":"user_dept_auth"};
          this.$refs.selectUserModal.visible = true;
        }
      },
      handleEdit: function (record) {
        this.$refs.modalForm.title = this.$t('button.edit');
        this.$refs.modalForm.departDisabled = true;
        this.$refs.modalForm.disableSubmit = false;
        this.$refs.modalForm.edit(record);
      },
      handleAdd: function () {
        if (this.currentDeptId == '') {
          this.$message.error("请选择一个部门!")
        } else {
          this.$refs.modalForm.departDisabled = true;
          this.$refs.modalForm.userDepartModel.departIdList = [this.currentDeptId];  //传入一个部门id
          this.$refs.modalForm.belongOrgId=this.currentDeptId;
          this.$refs.modalForm.add();
          this.$refs.modalForm.title = this.$t('button.add');
        }
      },
      selectOK(data) {
        let params = {};
        params.depId = this.currentDeptId;
        params.userIdList = [];
        for (var a = 0; a < data.length; a++) {
          params.userIdList.push(data[a]);
        }
        postAction(this.url.edit, params).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.loadData();
          } else {
            this.$message.warning(res.message);
          }
        })
      },
      handleDeptRole(record){
        if(this.currentDeptId != ''){
          this.$refs.deptRoleUser.add(record,this.currentDeptId);
          this.$refs.deptRoleUser.title = "部门角色分配";
        }else{
          this.$message.warning("请先选择一个部门!");
        }
      }
    }
  }
</script>
<style scoped>
/deep/ .ant-card-body {
  padding: 0;
}
  /** Button按钮间距 */
  .ant-btn {
    margin-left: 3px
  }

  /*.ant-card {*/
  /*  margin-left: -30px;*/
  /*  margin-right: -30px;*/
  /*}*/

  .table-page-search-wrapper {
    margin-top: -16px;
    margin-bottom: 16px;
  }
</style>